module.exports = __webpack_public_path__ + "static/media/logo.ff9d0dd9.svg";